import { lazy } from 'react';

// project imports
import Loadable from '../components/Loadable';
import DashboardLayout from '../layout/Dashboard';
import PagesLayout from '../layout/Pages';
import SimpleLayout from '../layout/Simple';

import { SimpleLayoutType } from '../config';

import AuthGuard from '../utils/route-guard/AuthGuard';
import VenueGuard from '../utils/route-guard/VenueGuard';

// pages routing
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

const AppContactUS = Loadable(lazy(() => import('pages/contact-us')));

// render - sample page
// const DashboardHome = Loadable(lazy(() => import('pages/dashboard/venues/dashboard')));

// Venue Dashboard Pages
const DashboardContact = Loadable(lazy(() => import('pages/dashboard/contact')));
const Logout = Loadable(lazy(() => import('pages/log-out')));

const VenueDashboard = Loadable(lazy(() => import('pages/dashboard/venues/dashboard')));
const VenueDashboardBands = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/bands')));
const VenueBandHolders = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/band-holders')));
// const VenueDashboardActivityLog = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/activity-log')));
const VenueParticipantView = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/participants/view')));
const ParticipantHistoricIncident = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/participants/incidents')));
const SingleParticipantIncidents = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/participants/incidents/single')));
const VenueDashboardLiveVenue = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/live')));
const VenueCheckedIn = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/venue')));
const VenueDashboardManagement = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/management')));
const VenueDashboardAssets = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/assets')));
const VenueAnalyticsAttendance = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/analytics/attendance')));
const VenueAnalyticsMilestones = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/analytics/milestones')));
const VenueAnalyticsGuestBands = Loadable(lazy(() => import('pages/dashboard/venues/dashboard/analytics/guestbands')));
const VenueActivities = Loadable(lazy(() => import('pages/dashboard/venues/activities')));
const VenueAddActivities = Loadable(lazy(() => import('pages/dashboard/venues/activities/new')));
const VenueEditActivities = Loadable(lazy(() => import('pages/dashboard/venues/activities/edit')));
const VenueBookables = Loadable(lazy(() => import('pages/dashboard/venues/bookings/bookables')));
const VenueAddBookables = Loadable(lazy(() => import('pages/dashboard/venues/bookings/bookables/new')));
const VenueEditBookables = Loadable(lazy(() => import('pages/dashboard/venues/bookings/bookables/edit')));
const VenueBookableActivities = Loadable(lazy(() => import('pages/dashboard/venues/bookings/bookableactivities')));
const VenueAddBookableActivity = Loadable(lazy(() => import('pages/dashboard/venues/bookings/bookableactivities/new')));
const VenueEditBookableActivity = Loadable(lazy(() => import('pages/dashboard/venues/bookings/bookableactivities/edit')));

const VenueBookings = Loadable(lazy(() => import('pages/dashboard/venues/bookings')));
// const VenueAddBookings = Loadable(lazy(() => import('pages/dashboard/venues/bookings/new')));
const VenueEditBookings = Loadable(lazy(() => import('pages/dashboard/venues/bookings/edit')));
const VenueBookingsCalendar = Loadable(lazy(() => import('pages/dashboard/venues/bookings/calendar')));

const VenueMemberships = Loadable(lazy(() => import('pages/dashboard/venues/memberships')));
const VenueParticipantMemberships = Loadable(lazy(() => import('pages/dashboard/venues/memberships/memberships')));
const VenueAddMemberships = Loadable(lazy(() => import('pages/dashboard/venues/memberships/new')));
const VenueEditMemberships = Loadable(lazy(() => import('pages/dashboard/venues/memberships/edit')));

const VenueSingleUseBands = Loadable(lazy(() => import('pages/dashboard/venues/single-use-bands')));
const VenuesingleUseBandRequest = Loadable(lazy(() => import('pages/dashboard/venues/single-use-bands/view')));

const VenueBookingUserTypes = Loadable(lazy(() => import('pages/dashboard/venues/bookings/usertypes')));
const VenueBookingAddUserTypes = Loadable(lazy(() => import('pages/dashboard/venues/bookings/usertypes/new')));
const VenueBookingEditUserTypes = Loadable(lazy(() => import('pages/dashboard/venues/bookings/usertypes/edit')));

const VenueCoupons = Loadable(lazy(() => import('pages/dashboard/venues/bookings/promocodes')));
const VenueAddCoupons = Loadable(lazy(() => import('pages/dashboard/venues/bookings/promocodes/new')));
const VenueEditCoupons = Loadable(lazy(() => import('pages/dashboard/venues/bookings/promocodes/edit')));

const VenueDataPoints = Loadable(lazy(() => import('pages/dashboard/venues/datapoints')));
const VenueAddDataPoints = Loadable(lazy(() => import('pages/dashboard/venues/datapoints/new')));
const VenueDetails = Loadable(lazy(() => import('pages/dashboard/venues/details')));
const VenueGuestBands = Loadable(lazy(() => import('pages/dashboard/venues/guestbands')));
const VenueAddGuestBands = Loadable(lazy(() => import('pages/dashboard/venues/guestbands/new')));
const VenueEditGuestBands = Loadable(lazy(() => import('pages/dashboard/venues/guestbands/edit')));
const VenueMilestones = Loadable(lazy(() => import('pages/dashboard/venues/milestones')));
const VenueAddMilestone = Loadable(lazy(() => import('pages/dashboard/venues/milestones/new')));
const VenueEditMilestone = Loadable(lazy(() => import('pages/dashboard/venues/milestones/edit')));
const UserSettings = Loadable(lazy(() => import('pages/dashboard/settings')));
const VenueStaff = Loadable(lazy(() => import('pages/dashboard/venues/staff')));
const VenueAddStaff = Loadable(lazy(() => import('pages/dashboard/venues/staff/new')));
const VenueSubscription = Loadable(lazy(() => import('pages/dashboard/venues/subscription')));
const VenueZones = Loadable(lazy(() => import('pages/dashboard/venues/zones')));
const VenueAddZone = Loadable(lazy(() => import('pages/dashboard/venues/zones/new')));
const VenueEditZone = Loadable(lazy(() => import('pages/dashboard/venues/zones/edit')));
const VenueViewZone = Loadable(lazy(() => import('pages/dashboard/venues/zones/view')));
const VenueIncidents = Loadable(lazy(() => import('pages/dashboard/venues/incidents')));
const VenueIncident = Loadable(lazy(() => import('pages/dashboard/venues/incidents/single')));

//Customer Service Pages
const CustomerServiceDashboard = Loadable(lazy(() => import('pages/dashboard/customer-services/dashboard')));
const CustomerServiceVenues = Loadable(lazy(() => import('pages/dashboard/customer-services/venues')));;
const CustomerServiceNewVenue = Loadable(lazy(() => import('pages/dashboard/customer-services/venues/new')));
const CustomerServiceSingleVenue = Loadable(lazy(() => import('pages/dashboard/customer-services/venues/single')));
const CustomerServiceAccounts = Loadable(lazy(() => import('pages/dashboard/customer-services/accounts')));
const CustomerServiceSingleAccount = Loadable(lazy(() => import('pages/dashboard/customer-services/accounts/single')));
const CustomerServiceParticipant = Loadable(lazy(() => import('pages/dashboard/customer-services/accounts/single/participant')));
const SingleParticipantBand = Loadable(lazy(() => import('pages/dashboard/customer-services/accounts/single/participant/band')));
const SingleParticipantIncidentsHistory = Loadable(lazy(() => import('pages/dashboard/customer-services/accounts/single/participant/incidents')));
const SingleParticipantIncident = Loadable(lazy(() => import('pages/dashboard/customer-services/accounts/single/participant/incidents/single')));
const CustomerServiceOrders = Loadable(lazy(() => import('pages/dashboard/customer-services/orders')));
const CustomerServiceSingleOrder = Loadable(lazy(() => import('pages/dashboard/customer-services/orders/single')));

//SuperAdmin Pages
const SuperAdminAPILog = Loadable(lazy(() => import('pages/dashboard/superadmin/apilog')));
const SuperAdminOrgSMSLog = Loadable(lazy(() => import('pages/dashboard/superadmin/orgsmslog')));
const SuperAdminSMSLog = Loadable(lazy(() => import('pages/dashboard/superadmin/smslog')));
const DBTablesBaseActivityTypes = Loadable(lazy(() => import('pages/dashboard/superadmin/dbtables/baseactivitytypes')));
const DBTablesCountry = Loadable(lazy(() => import('pages/dashboard/superadmin/dbtables/country')));
const DBTablesCutOffDefinitions = Loadable(lazy(() => import('pages/dashboard/superadmin/dbtables/cutoffdefinitions')));
const DBTablesMembershipFeatures = Loadable(lazy(() => import('pages/dashboard/superadmin/dbtables/membershipfeatures')));
const DBTablesMilestoneBadges = Loadable(lazy(() => import('pages/dashboard/superadmin/dbtables/milestonebadges')));
const DBTablesOrgSubsLevels = Loadable(lazy(() => import('pages/dashboard/superadmin/dbtables/orgsubslevels')));
const DBTablesSubsLevels = Loadable(lazy(() => import('pages/dashboard/superadmin/dbtables/subslevels')));
const DBTablesSuperAdmins = Loadable(lazy(() => import('pages/dashboard/superadmin/dbtables/superadmins')));
const DBTablesVatRates = Loadable(lazy(() => import('pages/dashboard/superadmin/dbtables/vatrates')));

// ==============================|| MAIN ROUTING ||============================== //

import { Navigate } from 'react-router-dom';
import DashboardLanding from './DashboardLanding';


const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <AuthGuard><DashboardLayout /></AuthGuard>,
      children: [
        {
          index: true,
          element: <DashboardLanding />
        },
        {
          path: 'logout',
          element: <Logout />
        },
        {
          path: '/dashboard/contact',
          element: <DashboardContact />
        },

        //CUSTOMER SERVICES / SUPER ADMIN
        {
          path: 'customer-services/dashboard',
          element: <CustomerServiceDashboard />
        },

        //Venues
        { path: 'customer-services/venues', element: <CustomerServiceVenues /> },
        { path: 'customer-services/venues/new', element: <CustomerServiceNewVenue /> },
        { path: 'customer-services/venues/:venueId', element: <CustomerServiceSingleVenue /> },
         
        //Accounts
        { path: 'customer-services/accounts', element: <CustomerServiceAccounts /> },
        { path: 'customer-services/accounts/:accountId', element: <CustomerServiceSingleAccount /> },
        { path: 'customer-services/accounts/:accountId/:participantId', element: <CustomerServiceParticipant /> },
        { path: 'customer-services/accounts/:accountId/:participantId/bands/:bandId', element: <SingleParticipantBand /> },
        { path: 'customer-services/accounts/:accountId/:participantId/incidents', element: <SingleParticipantIncidentsHistory /> },
        { path: 'customer-services/accounts/:accountId/:participantId/incidents/:incidentId', element: <SingleParticipantIncident /> },

        //Orders
        { path: 'customer-services/orders', element: <CustomerServiceOrders /> },
        { path: 'customer-services/orders/:orderId', element: <CustomerServiceSingleOrder /> },

        //SuperAdmin
        { path: 'superadmin/dashboard/apilog', element: <SuperAdminAPILog /> },
        { path: 'superadmin/dashboard/orgsmslog', element: <SuperAdminOrgSMSLog /> },
        { path: 'superadmin/dashboard/smslog', element: <SuperAdminSMSLog /> },
        { path: 'superadmin/dashboard/dbtables/baseactivitytypes', element: <DBTablesBaseActivityTypes /> },
        { path: 'superadmin/dashboard/dbtables/country', element: <DBTablesCountry /> },
        { path: 'superadmin/dashboard/dbtables/cutoffdefinitions', element: <DBTablesCutOffDefinitions /> },
        { path: 'superadmin/dashboard/dbtables/membershipfeatures', element: <DBTablesMembershipFeatures /> },
        { path: 'superadmin/dashboard/dbtables/milestonebadges', element: <DBTablesMilestoneBadges /> },
        { path: 'superadmin/dashboard/dbtables/orgsubslevels', element: <DBTablesOrgSubsLevels /> },
        { path: 'superadmin/dashboard/dbtables/subslevels', element: <DBTablesSubsLevels /> },
        { path: 'superadmin/dashboard/dbtables/superadmins', element: <DBTablesSuperAdmins /> },
        { path: 'superadmin/dashboard/dbtables/vatrates', element: <DBTablesVatRates /> },

        //VENUE ADMIN — staff = any venue member, admin = venue admin / super admin

        // Dashboard & Live View — both can view
        { path: 'dashboard/venue/:venueID', element: <VenueGuard><VenueDashboardLiveVenue /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/bands', element: <VenueGuard><VenueDashboardBands /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/band-holders', element: <VenueGuard><VenueBandHolders /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/participants/:participantID', element: <VenueGuard><VenueParticipantView /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/participants/:participantID/incidents', element: <VenueGuard><ParticipantHistoricIncident /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/participants/:participantID/incidents/:incidentID', element: <VenueGuard><SingleParticipantIncidents /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/live', element: <VenueGuard><VenueCheckedIn /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage', element: <VenueGuard><VenueDashboardManagement /></VenueGuard> },

        // Analytics — both can view (export restricted in-page via useVenueRole)
        { path: 'dashboard/venue/:venueID/analytics/attendance', element: <VenueGuard><VenueAnalyticsAttendance /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/analytics/incidents', element: <VenueGuard><VenueIncidents /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/analytics/milestones', element: <VenueGuard><VenueAnalyticsMilestones /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/analytics/guest-bands', element: <VenueGuard><VenueAnalyticsGuestBands /></VenueGuard> },

        // Assets — both can view
        { path: 'dashboard/venue/:venueID/manage/assets', element: <VenueGuard><VenueDashboardAssets /></VenueGuard> },

        // Venue Details — admin can edit, staff can view (handled in-page)
        { path: 'dashboard/venue/:venueID/manage/details', element: <VenueGuard><VenueDetails /></VenueGuard> },

        // Zones — admin can add/edit, staff can view list
        { path: 'dashboard/venue/:venueID/manage/zones', element: <VenueGuard><VenueZones /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage/zones/new', element: <VenueGuard requiredRole="admin"><VenueAddZone /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage/zones/edit/:zoneID', element: <VenueGuard requiredRole="admin"><VenueEditZone /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage/zones/:zoneID', element: <VenueGuard><VenueViewZone /></VenueGuard> },

        // Activities — admin can add/edit, staff can view list
        { path: 'dashboard/venue/:venueID/manage/activities', element: <VenueGuard><VenueActivities /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage/activities/new', element: <VenueGuard requiredRole="admin"><VenueAddActivities /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage/activities/edit/:activityID', element: <VenueGuard requiredRole="admin"><VenueEditActivities /></VenueGuard> },

        // Staff — admin can add/delete, staff can view list
        { path: 'dashboard/venue/:venueID/manage/staff', element: <VenueGuard><VenueStaff /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage/staff/new', element: <VenueGuard requiredRole="admin"><VenueAddStaff /></VenueGuard> },

        // Milestones — admin can add/edit/delete, staff can view list
        { path: 'dashboard/venue/:venueID/manage/milestones', element: <VenueGuard><VenueMilestones /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage/milestones/new', element: <VenueGuard requiredRole="admin"><VenueAddMilestone /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage/milestones/edit/:milestoneID', element: <VenueGuard requiredRole="admin"><VenueEditMilestone /></VenueGuard> },

        // Guest Bands — admin can add/edit/delete, staff can view list
        { path: 'dashboard/venue/:venueID/manage/guest-bands', element: <VenueGuard><VenueGuestBands /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage/guest-bands/assign/:guestbandID', element: <VenueGuard requiredRole="admin"><VenueAddGuestBands /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage/guest-bands/edit/:guestbandID', element: <VenueGuard requiredRole="admin"><VenueEditGuestBands /></VenueGuard> },

        // Bookings — both can do everything
        { path: 'dashboard/venue/:venueID/bookings/calendar', element: <VenueGuard><VenueBookingsCalendar /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/bookings/view', element: <VenueGuard><VenueBookings /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/bookings/edit/:bookingID', element: <VenueGuard><VenueEditBookings /></VenueGuard> },

        // Bookables — admin can add/edit/delete, staff can view listing
        { path: 'dashboard/venue/:venueID/bookables', element: <VenueGuard><VenueBookables /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/bookables/new', element: <VenueGuard requiredRole="admin"><VenueAddBookables /></VenueGuard> },
        // { path: 'dashboard/venue/:venueID/bookables/edit/:bookableID', element: <VenueGuard requiredRole="admin"><VenueEditBookables /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/bookables/edit/:bookableID', element: <VenueGuard><VenueEditBookables /></VenueGuard> },

        // Bookable Activities — admin can add/edit/delete, staff can view listing
        { path: 'dashboard/venue/:venueID/bookings/bookableactivities', element: <VenueGuard><VenueBookableActivities /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/bookings/bookableactivities/new', element: <VenueGuard requiredRole="admin"><VenueAddBookableActivity /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/bookings/bookableactivities/edit/:bookableActivityID', element: <VenueGuard requiredRole="admin"><VenueEditBookableActivity /></VenueGuard> },

        // UserTypes — admin can add/edit/delete, staff can view listing
        { path: 'dashboard/venue/:venueID/bookings/usertypes', element: <VenueGuard><VenueBookingUserTypes /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/bookings/usertypes/new', element: <VenueGuard requiredRole="admin"><VenueBookingAddUserTypes /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/bookings/usertypes/edit/:usertypeID', element: <VenueGuard requiredRole="admin"><VenueBookingEditUserTypes /></VenueGuard> },

        // Coupons — admin can add/edit/delete, staff can view listing
        { path: 'dashboard/venue/:venueID/bookings/promocodes', element: <VenueGuard><VenueCoupons /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/bookings/promocodes/new', element: <VenueGuard requiredRole="admin"><VenueAddCoupons /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/bookings/promocodes/edit/:couponID', element: <VenueGuard requiredRole="admin"><VenueEditCoupons /></VenueGuard> },

        // Memberships — admin can add/edit, staff can view listing
        { path: 'dashboard/venue/:venueID/memberships/plans', element: <VenueGuard><VenueMemberships /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/memberships/participants', element: <VenueGuard><VenueParticipantMemberships /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/memberships/plans/new', element: <VenueGuard requiredRole="admin"><VenueAddMemberships /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/memberships/plans/edit/:membershipID', element: <VenueGuard><VenueEditMemberships /></VenueGuard> },

        // Single Use Bands — both can view
        { path: 'dashboard/venue/:venueID/single-use-bands', element: <VenueGuard><VenueSingleUseBands /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/single-use-bands/:requestID', element: <VenueGuard><VenuesingleUseBandRequest /></VenueGuard> },

        // DataPoints — admin can add/edit, staff can view list
        { path: 'dashboard/venue/:venueID/manage/datapoints', element: <VenueGuard><VenueDataPoints /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage/datapoints/new', element: <VenueGuard requiredRole="admin"><VenueAddDataPoints /></VenueGuard> },

        // Incidents — both can view and edit
        { path: 'dashboard/venue/:venueID/manage/incidents', element: <VenueGuard><VenueIncidents /></VenueGuard> },
        { path: 'dashboard/venue/:venueID/manage/incidents/view/:incidentID', element: <VenueGuard><VenueIncident /></VenueGuard> },

        // Subscription — both can view (upgrade button restricted in-page via useVenueRole)
        { path: 'dashboard/venue/:venueID/settings/subscription', element: <VenueGuard><VenueSubscription /></VenueGuard> },

        // User
        { path: 'dashboard/settings', element: <UserSettings /> },
        {
          path: '*',
          element: <MaintenanceError />
        }

      ]
    },

    // Maintenance Routes
    {
      path: '/maintenance',
      element: <PagesLayout />,
      children: [
        { path: '404', element: <MaintenanceError /> },
        { path: '500', element: <MaintenanceError500 /> },
        { path: 'under-construction', element: <MaintenanceUnderConstruction /> },
        { path: 'coming-soon', element: <MaintenanceComingSoon /> },
      ]
    },

    // Public Simple Routes
    {
      path: '/',
      element: <SimpleLayout layout={SimpleLayoutType.SIMPLE} />,
      children: [
        { path: 'contact-us', element: <AppContactUS /> },
      ]
    }
  ]
};

export default MainRoutes;
